export const LoginInfo = "User";
export const LogoutInfo = "remUser";